import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../page/about";
// import Logo from "../../asset/logo.png";
import { Link } from "react-router-dom";
import Res from "../../asset/res.jpg";

import Navbar from "../navbar";
import Footer from "../Footer";

const Resource = () => {
  const data = [{ button: "Contact US", path: "/contactus" }];
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">Resource Center</Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ display: "flex", justifyContent: "center", padding: "50px 0" }}
      >
        <Grid item md={5}>
          <Typography className="restxt2">
            A number of useful resources on Islam can be found here:
          </Typography>
          <ul>
            <li className="restxt">
              <a href="https://islameasy.org/">An Introduction to Islam </a>
            </li>
            <li className="restxt">
              <a href="https://www.whyislam.org/">
                Facts about Muslims and Islam
              </a>
            </li>
            <li className="restxt">
              <a href="https://quran.com/">The Noble Quran</a>
            </li>
            <li className="restxt">
              <a href="https://www.islamicity.org/">
                IslamiCity – An Online Portal on Islam
              </a>
            </li>
            <li className="restxt">
              <a href="https://icnaconvention.org/">
                Islamic Circle of North America
              </a>
            </li>
            <li className="restxt">
              <a href="https://isna.net/">Islamic Society of North America</a>
            </li>
            <li className="restxt">
              <a href="http://www.zabihah.com/">
                Guide to Halal Restaurants and Markets
              </a>
            </li>
            <li className="restxt">
              <a href="https://islamqa.org/">Questions and Answers on Islam</a>
            </li>
          </ul>
        </Grid>
        <Grid
          item
          className="res-img"
          xs={10}
          md={5}
          sx={{ display: "flex", justifyContent: "end" }}
        >
          <img className="One" src={Res} alt="nothing" />
        </Grid>
        <Grid
          item
          md={10}
          sx={{ display: "flex", justifyContent: "center", paddingTop: "30px" }}
        >
          <Typography
            className="dis-txt"
            sx={{ fontWeight: "700", fontSize: "10px" }}
          >
            (Disclaimer: The links presented on this Resource Center page are to
            external websites which are not affiliated with the Islamic Center
            of Cape Code. ICCC is not responsible for the any of the content of
            these websites, and the views, opinions and content on these
            websites are solely those of the authors of those sites and do not
            represent ICCC.)
          </Typography>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default Resource;
